var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"question-circle","size":"lg"},on:{"click":function($event){$event.stopPropagation();return _vm.showQuiz()}}})}
var staticRenderFns = []

export { render, staticRenderFns }